import './CarModelLuxuryBlock.scss';

import React from 'react';
import { Image, RichText } from '@sitecore-jss/sitecore-jss-react';
import { useMediaQuery } from 'usehooks-ts';

export default function CarModelLuxuryBlock({ fields }) {
  const isMobile = useMediaQuery('(max-width: 480px)');
  const imgUrl = isMobile ? fields?.imageMobile : fields?.image;
  return (
    <div className={'container car-model-luxury-block'}>
      <div className={'wrapper'} id="Specs">
        <div className={'content'}>
          <h2 className={'content_title'} data-aos="fade-up">
            <RichText field={fields.titleText} />
          </h2>
          <ul className={'content_list'}>
            {fields.itemList.map((item) => {
              return (
                <li key={item.fields.id.value} className={'content_list_item'} data-aos="fade-up">
                  <p className={'content_list_item_title'}>{item.fields.column.value}</p>
                  <p className={'content_list_item_text'}>{item.fields.result.value}</p>
                </li>
              );
            })}
          </ul>
        </div>
        <div className={'image'} data-aos="fade-up">
          <Image className={'img'} field={imgUrl} alt={'img'} fill />
        </div>
      </div>
    </div>
  );
}
